/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {$Container, $Sprite, FC} from '../../../core/fragments/BuilderY';

export const $BigWinParticles: FC = () => {
    return <$Container name='bigWinParticles'>
        <$Container name='diamond'>
            <$Sprite texture='diamond_particle_00000' />
            <$Sprite texture='diamond_particle_00001' />
            <$Sprite texture='diamond_particle_00002' />
            <$Sprite texture='diamond_particle_00003' />
            <$Sprite texture='diamond_particle_00004' />
            <$Sprite texture='diamond_particle_00005' />
            <$Sprite texture='diamond_particle_00006' />
            <$Sprite texture='diamond_particle_00007' />
            <$Sprite texture='diamond_particle_00008' />
            <$Sprite texture='diamond_particle_00009' />
            <$Sprite texture='diamond_particle_00010' />
            <$Sprite texture='diamond_particle_00011' />
            <$Sprite texture='diamond_particle_00012' />
            <$Sprite texture='diamond_particle_00013' />
            <$Sprite texture='diamond_particle_00014' />
            <$Sprite texture='diamond_particle_00015' />
            <$Sprite texture='diamond_particle_00016' />
            <$Sprite texture='diamond_particle_00017' />
            <$Sprite texture='diamond_particle_00018' />
            <$Sprite texture='diamond_particle_00019' />
        </$Container>
        <$Container name='yuan'>
            <$Sprite texture='yuan_particle_00000' />
            <$Sprite texture='yuan_particle_00001' />
            <$Sprite texture='yuan_particle_00002' />
            <$Sprite texture='yuan_particle_00004' />
            <$Sprite texture='yuan_particle_00003' />
            <$Sprite texture='yuan_particle_00005' />
            <$Sprite texture='yuan_particle_00006' />
            <$Sprite texture='yuan_particle_00007' />
            <$Sprite texture='yuan_particle_00008' />
            <$Sprite texture='yuan_particle_00009' />
            <$Sprite texture='yuan_particle_00010' />
            <$Sprite texture='yuan_particle_00011' />
            <$Sprite texture='yuan_particle_00012' />
            <$Sprite texture='yuan_particle_00013' />
            <$Sprite texture='yuan_particle_00014' />
            <$Sprite texture='yuan_particle_00015' />
            <$Sprite texture='yuan_particle_00016' />
            <$Sprite texture='yuan_particle_00017' />
            <$Sprite texture='yuan_particle_00018' />
            <$Sprite texture='yuan_particle_00019' />
        </$Container>
        <$Container name='coin'>
            <$Sprite texture='coin_particle_00000' />
            <$Sprite texture='coin_particle_00001' />
            <$Sprite texture='coin_particle_00002' />
            <$Sprite texture='coin_particle_00003' />
            <$Sprite texture='coin_particle_00004' />
            <$Sprite texture='coin_particle_00005' />
            <$Sprite texture='coin_particle_00006' />
            <$Sprite texture='coin_particle_00007' />
            <$Sprite texture='coin_particle_00008' />
            <$Sprite texture='coin_particle_00009' />
            <$Sprite texture='coin_particle_00010' />
            <$Sprite texture='coin_particle_00011' />
            <$Sprite texture='coin_particle_00012' />
            <$Sprite texture='coin_particle_00013' />
            <$Sprite texture='coin_particle_00014' />
            <$Sprite texture='coin_particle_00015' />
            <$Sprite texture='coin_particle_00016' />
            <$Sprite texture='coin_particle_00017' />
            <$Sprite texture='coin_particle_00018' />
            <$Sprite texture='coin_particle_00019' />
        </$Container>
    </$Container>;
};
